import FidusELearning from "./Assets/video/Fidus-ELearning.mp4";
import "./home.css";
import FidusDifference from "./HomeComponents/FidusDifference";
import OurJourney from "./HomeComponents/OurJourney";
import OurExpertise from "./HomeComponents/OurExpertise";
import WhyChooseUs from "./HomeComponents/WhyChooseUs";
import WhoWeAre from "./HomeComponents/WhoWeAre";
import WhatWeDo from "./HomeComponents/WhatWeDo";
import WhatWeLike from "./HomeComponents/WhatWeLike";
import TrainingModule from "./HomeComponents/TrainingModule";
import OurDomain from "./HomeComponents/OurDomain";
import OurProducts from "./HomeComponents/OurProducts";
import Blogs from "./HomeComponents/Blogs";
import FooterCTA from "./HomeComponents/FooterCTA";

const Home = () => {
  return (
    <>
      <div className="banner section" id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>Discover Engage Succeed!</h1>
          <p>
            Harness the Power of E-Learning Interactive Courses Anytime,
            Anywhere!"
          </p>
        </div>
      </div>
      <div className="our_journey_video_section">
        <div className="our_journey_video">

          <video width="100%" autoPlay muted controls>
            <source src={FidusELearning} type="video/mp4" />
            Your browser does not support HTML video.
          </video>
        </div>
      </div>
      <div className="elearning-section">
        <div className="elearning-iconbg"></div>
        <div className="elearning-learning">
          <h1>Here to make Leaning easier and more enjoyable for you!</h1>
          <span>
            <svg
              width="181"
              height="181"
              viewBox="0 0 181 181"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M50.8945 163.113L129.206 163.564"
                stroke="#58DBDF"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M73.4631 129.683C73.3955 141.43 69.3995 155.391 63.2015 163.187"
                stroke="#58DBDF"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M116.899 163.495C110.791 155.628 106.956 141.622 107.023 129.875"
                stroke="#58DBDF"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M90.3387 112.995L90.6605 57.0589C90.7152 47.5496 83.4852 40.2361 73.976 40.1814L40.4141 39.9883L40.0923 95.9249L73.6542 96.1179C83.1634 96.1726 90.3934 103.486 90.3387 112.995Z"
                stroke="#007A96"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M90.3395 112.999L90.6613 57.0622C90.716 47.553 98.0296 40.3231 107.539 40.3778L141.101 40.5709L140.779 96.5074L107.217 96.3144C97.7078 96.2597 90.3942 103.49 90.3395 112.999Z"
                stroke="#007A96"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.0724 34.2693L17.5897 118.174C17.5543 124.327 22.5596 129.39 28.7126 129.426L151.773 130.134C157.926 130.169 162.989 125.164 163.025 119.011L163.507 35.106C163.543 28.953 158.538 23.8897 152.384 23.8543L29.324 23.1464C23.171 23.111 18.1078 28.1163 18.0724 34.2693Z"
                stroke="#58DBDF"
                strokeWidth="7"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      <FidusDifference />
      <OurJourney />
      <OurExpertise hideOnMobile={true} />
      <WhyChooseUs hideOnMobile={true} />
      <WhoWeAre hideOnMobile={true} />
      <WhatWeDo hideOnMobile={true} />
      <WhatWeLike hideOnMobile={true} />
      <TrainingModule hideOnMobile={true} />
      <OurDomain />
      <OurProducts />
      {/* <MeetTheTeam /> */}
      <Blogs />
      <FooterCTA />
    </>
  );
};

export default Home;
